import alt from 'components/Dispatcher';
import immutableStore from 'utils/immutableStore';
import {List, Record} from 'immutable';
import DashboardHistoryActions from 'actions/dashboard/DashboardHistoryActions';

@immutableStore
class DashboardHistoryStore {
  constructor() {
    this.state = new Record({
      history: List(),
    })();
    this.bindActions(DashboardHistoryActions);
  }

  pushHistorySuccess(path) {
    if (!path) return;
    const history = this.state.history;
    const last = history.last();
    if (path !== last) {
      const newHistory = history.push(path);
      const state = this.state.set('history', newHistory);
      this.setState(state);
    }
  }

  popHistorySuccess(expected) {
    if (!expected) return;
    const history = this.state.history;
    if (expected === history.last()) {
      const newHistory = history.pop();
      const state = this.state.set('history', newHistory);
      this.setState(state);
    }
  }

  resetHistorySuccess() {
    const state = this.state.set('history', List());
    this.setState(state);
  }
}

export default alt.createStore(DashboardHistoryStore, 'DashboardHistoryStore');
